export default "__VITE_ASSET__CrRWHclV__"